import { DataType, ReadWrite, RegisterTable } from "../lib/inverter.model";

export const V1RealTimeConfig = {
  Fault: {
    indexToStart: 1,
    start: 0x0001,
    length:5,
  },
};

export const V2RealTimeConfig = {
  Fault: {
    indexToStart: 1,
    start: 0x0201,
    length:5,
  },
};

export const V3RealTimeConfig = {
  Fault_first_section: {
    indexToStart: 1,
    start: 0x0405,
    length: 18,
  },
  Fault_second_section: {
    indexToStart: 19,
    start: 0x0432,
    length: 9,
  },
  Temperature_env: {
    start: 0x0418,
    length: 2,
    post: 'Env',
  },
  Temperature_heatSink: {
    start: 0x041A,
    length: 6,
    post: 'HeatSink',
  },
  Temperature_inv: {
    start: 0x0420,
    length: 3,
    post: 'Inv',
  },
  Batteries_first_section: {
    start: 0x0604,
    length: 8,
    indexToStart: 1,
  },
  Batteries_second_section: {
    start: 0x0644,
    length: 4,
    indexToStart: 9,
  },
};

export const V3BmsRealTimeConfig = {
  Pack_RT_Cell_Voltage: {
    indexToStart: 1,
    start: 0x9051,
    length: 24,
  },
};

export const V3BmsFaultConfig = {
  Pack_Fault_Cell_Voltage: {
    indexToStart: 1,
    start: 0x9091,
    length: 24,
  },
};

export const createPackRTCellVoltage = (index: number, address: number): Partial<RegisterTable> => ({
  pack_rt_cell_voltage: {
    address,
    name: `Pack_RT_Cell_Voltage${index}`,
    dataType: DataType.U16,
    unit: 'V',
    accuracy: 0.001,
    access: ReadWrite.Read,
    description: `Cell ${index} voltage`,
    quantity: 1,
  },
});

export const createPackFaultCellVoltage = (index: number, address: number): Partial<RegisterTable> => ({
  pack_fault_cell_voltage: {
    address,
    name: `Pack_Fault_Cell_Voltage${index}`,
    dataType: DataType.U16,
    unit: 'V',
    accuracy: 0.001,
    access: ReadWrite.Read,
    description: `Cell ${index} voltage`,
    quantity: 1,
    custom: {
      translate: `Cell ${index}`,
    },
  },
});

export const createTemperature = (index: number, address: number, post: string): Partial<RegisterTable> => ({
  temperature: {
    address,
    name: `Temperature_${post}${index}`,
    dataType: DataType.I16,
    unit: '°C',
    accuracy: 1,
    access: ReadWrite.Read,
    description: `Temperature_${post}${index}`,
    quantity: 1,
  },
});

export const createFault = (index: number, address: number): Partial<RegisterTable> => ({
  fault: {
    address,
    name: `Fault${index}`,
    dataType: DataType.I16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: `Fault${index}`,
    quantity: 1,
  },
});

export const V3InternalEnergyConfig = {
  V_C_P_pv: {
    start: 0x0584,
    length: 16,
  },
};

export const V3InputTypeChannelConfig = {
  Input_Type: {
    start: 0x1011,
    length: 16,
  },
};

export const create_V_C_P_pv = (index: number, vAddress: number, cAddress: number, pAddress: number): Partial<RegisterTable> => ({
  v_pv: {
    address: vAddress,
    name: `Voltage_PV${index}`,
    dataType: DataType.I16,
    unit: 'V',
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: `pv${index} voltage`,
    quantity: 1,
  },
  c_pv: {
    address: cAddress,
    name: `Current_PV${index}`,
    dataType: DataType.I16,
    unit: 'A',
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: `pv${index} current`,
    quantity: 1,
  },
  p_pv: {
    address: pAddress,
    name: `Power_PV${index}`,
    dataType: DataType.I16,
    unit: 'kW',
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: `pv${index} power`,
    quantity: 1,
  },
});

export const create_HistoryEventList = (
  index: number,
  address: number,
): Partial<RegisterTable> => ({
  id: {
    address,
    name: `HistoryEventList_ID${index}`,
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: `HistoryEventList_ID${index}`,
    quantity: 1,
  },
  yM: {
    address: address + 1,
    name: `HistoryEventList_yM${index}`,
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: `HistoryEventList_yM${index}`,
    quantity: 1,
  },
  dH: {
    address: address + 2,
    name: `HistoryEventList_dH${index}`,
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: `HistoryEventList_dH${index}`,
    quantity: 1,
  },
  ms: {
    address: address + 3,
    name: `HistoryEventList_ms${index}`,
    dataType: DataType.U16,
    unit: '',
    accuracy: 1,
    access: ReadWrite.Read,
    description: `HistoryEventList_ms${index}`,
    quantity: 1,
  },
});

export const create_bat_config = (index: number, vAddress: number): Partial<RegisterTable> => ({
  v_bat: {
    address: vAddress,
    name: `Voltage_Bat${index}`,
    dataType: DataType.U16,
    unit: 'V',
    access: ReadWrite.Read,
    description: `Battery Voltage, String ${index}`,
    quantity: 1,
    accuracy: 0.1,
  },
  c_bat: {
    address: vAddress + 1,
    name: `Current_Bat${index}`,
    dataType: DataType.I16,
    unit: 'A',
    access: ReadWrite.Read,
    description: `Battery Charge & Discharge Current?positive+,negative -, String ${index}`,
    quantity: 1,
    accuracy: 0.01,
  },
  p_bat: {
    address: vAddress + 2,
    name: `Power_Bat${index}`,
    dataType: DataType.I16,
    unit: 'kW',
    access: ReadWrite.Read,
    description: `Battery Charge & Discharge Power?positive+,negative -, String ${index}`,
    quantity: 1,
    accuracy: 0.01,
  },
  t_env_bat: {
    address: vAddress + 3,
    name: `Temperature_Env_Bat${index}`,
    dataType: DataType.I16,
    access: ReadWrite.Read,
    description: `Battery Ambient Temperature, String ${index}`,
    quantity: 1,
    accuracy: 1,
  },
  soc_bat: {
    address: vAddress + 4,
    name: `SOC_Bat${index}`,
    dataType: DataType.U16,
    unit: '%',
    access: ReadWrite.Read,
    description: `Battery SOC,String ${index}`,
    quantity: 1,
    accuracy: 1,
  },
  soh_bat: {
    address: vAddress + 5,
    name: `SOH_Bat${index}`,
    dataType: DataType.U16,
    unit: '%',
    access: ReadWrite.Read,
    description: `Battery SOH,String ${index}`,
    quantity: 1,
    accuracy: 1,
  },
  chargeCycle_bat: {
    address: vAddress + 6,
    name: `ChargeCycle_Bat${index}`,
    dataType: DataType.U16,
    unit: 'cycle',
    access: ReadWrite.Read,
    description: `Battery cycle times .String ${index}`,
    quantity: 1,
    accuracy: 1,
  },
});

export const V3HistoryEventsConfig = {
  HistoryEvents: {
    address: 0x1480,
    indexStart: 1,
    length: 100,
  },
};

export const create_input_type_channel_config = (index: number, vAddress: number): Partial<RegisterTable> => ({
  input_type: {
    address: vAddress,
    name: `InputType_Channel${index}`,
    dataType: DataType.U16,
    unit: '',
    access: ReadWrite.Read,
    description: `Input Type of Channel ${index}`,
    quantity: 1,
  },
});

export const V3AutoTestConfig = {
  AutoTest_results_v: {
    start: 0x1304,
    length: 4,
  },
  AutoTest_results_hz: {
    start: 0x1314,
    length: 4,
  },
};

export const create_auto_test_result_v = (index: number, vAddress: number): Partial<RegisterTable> => ({
  auto_test_result_v_default: {
    address: vAddress,
    name: `AutoTestResult_v_default_${index}`,
    dataType: DataType.U16,
    unit: 'v',
    access: ReadWrite.Read,
    description: `Auto Test Result ${index}`,
    quantity: 1,
    accuracy: 0.1,
  },
  auto_test_result_ms_default: {
    address: vAddress + 1,
    name: `AutoTestResult_ms_default_${index}`,
    dataType: DataType.U16,
    unit: 'ms',
    access: ReadWrite.Read,
    description: `Auto Test Result ${index}`,
    quantity: 1,
    accuracy: 1,
  },
  auto_test_result_v: {
    address: vAddress + 2,
    name: `AutoTestResult_v_${index}`,
    dataType: DataType.U16,
    unit: 'v',
    access: ReadWrite.Read,
    description: `Auto Test Result ${index}`,
    quantity: 1,
    accuracy: 0.1,
  },
  auto_test_result_ms: {
    address: vAddress + 3,
    name: `AutoTestResult_ms_${index}`,
    dataType: DataType.U16,
    unit: 'ms',
    access: ReadWrite.Read,
    description: `Auto Test Result ${index}`,
    quantity: 1,
    accuracy: 1,
  },
});

export const create_auto_test_result_hz = (index: number, vAddress: number): Partial<RegisterTable> => ({
  auto_test_result_hz_default: {
    address: vAddress,
    name: `AutoTestResult_hz_${index}`,
    dataType: DataType.U16,
    unit: 'v',
    access: ReadWrite.Read,
    description: `Auto Test Result ${index}`,
    quantity: 1,
    accuracy: 0.01,
  },
  auto_test_result_ms_default: {
    address: vAddress + 1,
    name: `AutoTestResult_ms_${index}`,
    dataType: DataType.U16,
    unit: 'ms',
    access: ReadWrite.Read,
    description: `Auto Test Result ${index}`,
    quantity: 1,
    accuracy: 1,
  },
  auto_test_result_hz: {
    address: vAddress + 2,
    name: `AutoTestResult_hz_${index}`,
    dataType: DataType.U16,
    unit: 'hz',
    access: ReadWrite.Read,
    description: `Auto Test Result ${index}`,
    quantity: 1,
    accuracy: 0.01,
  },
  auto_test_result_ms: {
    address: vAddress + 3,
    name: `AutoTestResult_ms_${index}`,
    dataType: DataType.U16,
    unit: 'ms',
    access: ReadWrite.Read,
    description: `Auto Test Result ${index}`,
    quantity: 1,
    accuracy: 1,
  },
});
